import { Box, Container, Image, Paper, Stack, Title } from '@mantine/core'
import logo from '@opsopti/shared/src/assets/logo.full.white.hybrid@2x.png'
import { observer } from 'mobx-react-lite'
import type { PropsWithChildren } from 'react'

import { theme } from '@/configs/theme'
import * as classes from '@/styles/AuthLayout.css'

import { GlobalLoadingOverlay } from './GlobalLoadingOverlay'
import { VersionButton } from './VersionButton'

type AuthLayoutProps = PropsWithChildren

export const AuthLayout = observer(function AuthLayout(props: AuthLayoutProps) {
  return (
    <Box className={classes.wrapper}>
      <Container className={classes.container}>
        <Stack align="center" py="xxxl">
          <Image src={logo} mb={16} mah={{ base: theme.rem(60), md: theme.rem(80) }} fit="contain" />

          <Title order={5} className={classes.splashText} ta="center">
            Your Route to Seamless Operations
          </Title>
        </Stack>

        <Paper className={classes.slot} radius="lg">
          {props.children}

          <GlobalLoadingOverlay />
        </Paper>
      </Container>

      <VersionButton className={classes.versionButton} />
    </Box>
  )
})
